export const breadcrumb = {
  title: 'Ref. program',
  user: {
    index: 'My referrals'
  },

  profit: {
    index: 'Accrual history'
  },

  request: {
    index: 'Withdrawal applications'
  }
};
